<template>
    <div class="input" :class="[{ focused }, search && 'search']">
        <div v-if="!!$slots['prefix']" class="slot prefix">
            <slot name="prefix"></slot>
        </div>
        <input
            :min="min"
            :max="max"
            :name="label"
            :value="value"
            :type="type"
            :placeholder="placeholder"
            :disabled="disabled"
            @focus="focus"
            @blur="blur"
            @input="input"
        />
        <div v-if="$slots.length" class="slot">
            <slot />
        </div>
        <div v-if="!!$slots['suffix']" class="slot suffix">
            <slot name="suffix"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Input',
    props: {
        min: {
            type: String,
            default: '',
            required: false,
        },
        max: {
            type: String,
            default: '',
            required: false,
        },
        label: {
            type: String,
            default: '',
            note: "the 'name' of the input",
            required: false,
        },
        type: {
            type: String,
            default: 'text',
            note: 'the type of the input',
        },
        value: {
            type: String,
            default: '',
            note: 'the current value of the input',
        },
        placeholder: {
            type: String,
            default: '',
            note: 'the placeholder for the input',
        },
        message: {
            type: String,
            default: '',
            note: 'message that will be displayed underneath the input',
        },
        disabled: {
            type: Boolean,
            default: false,
            note: "the input can be disabled. The appereance changes and there can't be any user input made.",
        },
        search: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            focused: false,
        }
    },
    methods: {
        focus() {
            this.focused = true
            this.$emit('focus')
        },
        blur() {
            this.focused = false
            this.$emit('blur')
        },
        input(data) {
            if (!this.disabled) this.$emit('input', data.target.value)
        },
    },
}
</script>

<style scoped lang="sass">
.input
    min-width: 300px
    background: $gray-2
    height: 38px
    display: flex
    border-radius: 5px
    align-items: center

    .slot
        padding: $s

    input
        flex: 1
        border: none
        background: none
        outline: none
        padding: 0 $s

    &.focused
        box-shadow: 0 0 0 1px $primary-2

.search
    background: $neutral-white
    box-shadow: $box-mois
</style>
